import { type ChangeSummaryValue } from "./components/change-summary";

/** Remount counters for the two identity cards, one each. */
export type CardRevisions = {
  readonly carrier: number;
  readonly customer: number;
};

export const INITIAL_CARD_REVISIONS: CardRevisions = {
  carrier: 0,
  customer: 0,
};

/**
 * Bumps the counter of the card whose save just landed, so that card remounts
 * from what the server stored. The other card keeps any unsaved edits, and a
 * partnership save leaves both alone.
 */
export const nextCardRevisions = (
  revisions: CardRevisions,
  scope: ChangeSummaryValue["scope"],
): CardRevisions => {
  switch (scope) {
    case "carrier": {
      return { ...revisions, carrier: revisions.carrier + 1 };
    }
    case "customer": {
      return { ...revisions, customer: revisions.customer + 1 };
    }
    case "partnership": {
      return revisions;
    }
  }
};

/** An import can change both identities, so both cards remount from the server. */
export const nextCardRevisionsAfterImport = (
  revisions: CardRevisions,
): CardRevisions => ({
  carrier: revisions.carrier + 1,
  customer: revisions.customer + 1,
});
